"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationContentObjectService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var LaunchDarkly_service_1 = require("../LaunchDarkly.service");
var JsonApi_service_1 = require("../jsonServiceApi/JsonApi.service");
var CollaborationContentObjectService = /** @class */ (function () {
    function CollaborationContentObjectService(jsonApiService, launchDarklyService) {
        this.jsonApiService = jsonApiService;
        this.launchDarklyService = launchDarklyService;
    }
    CollaborationContentObjectService.prototype.getCollaborationContentInfo = function (id) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CollaborationContentInfo', {
            query: { id: id },
            retryCallback: function () { return _this.getCollaborationContentInfo(id); },
        });
    };
    CollaborationContentObjectService.prototype.getFolderDecedentsCollaborationContent = function (folderId, isForLiveSendOrLiveShare) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'FolderDecedentsCollaborationContent', {
            query: { folderId: folderId, isForLiveSendOrLiveShare: isForLiveSendOrLiveShare },
            retryCallback: function () { return _this.getFolderDecedentsCollaborationContent(folderId, isForLiveSendOrLiveShare); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentInfoByVersionId = function (vid, dlv) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CollaborationContentInfoByVersionId', {
            query: { vid: vid, dlv: dlv },
            retryCallback: function () { return _this.getCollaborationContentInfoByVersionId(vid, dlv); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentDetailInfo = function (vid, includeDO, includePrevVersionsInfo) {
        if (includeDO === void 0) { includeDO = 'True'; }
        if (includePrevVersionsInfo === void 0) { includePrevVersionsInfo = 'True'; }
        return __awaiter(this, void 0, void 0, function () {
            var enableEditingStatusEnhance;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.launchDarklyService.getValueAsBoolean('library-enable-freestyle-editing-status-enhance')];
                    case 1:
                        enableEditingStatusEnhance = _a.sent();
                        return [2 /*return*/, this.jsonApiService.get('CollaborationContentObjectService', enableEditingStatusEnhance ? 'CollaborationContentDetailInfoV2' : 'CollaborationContentDetailInfo', {
                                query: { vid: vid, includeDO: includeDO, includePrevVersionsInfo: includePrevVersionsInfo },
                                retryCallback: function () { return _this.getCollaborationContentDetailInfo(vid, includeDO, includePrevVersionsInfo); },
                            })];
                }
            });
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentDetailInfoById = function (id, includeDO, includePrevVersionsInfo) {
        if (includeDO === void 0) { includeDO = 'True'; }
        if (includePrevVersionsInfo === void 0) { includePrevVersionsInfo = 'True'; }
        return __awaiter(this, void 0, void 0, function () {
            var enableEditingStatusEnhance;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.launchDarklyService.getValueAsBoolean('library-enable-freestyle-editing-status-enhance')];
                    case 1:
                        enableEditingStatusEnhance = _a.sent();
                        return [2 /*return*/, this.jsonApiService.get('CollaborationContentObjectService', enableEditingStatusEnhance ? 'CollaborationContentDetailInfoByIdV2' : 'CollaborationContentDetailInfoById', {
                                query: { id: id, includeDO: includeDO, includePrevVersionsInfo: includePrevVersionsInfo },
                                retryCallback: function () { return _this.getCollaborationContentDetailInfoById(id, includeDO, includePrevVersionsInfo); },
                            })];
                }
            });
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentPageThumbnails = function (vid) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CollaborationContentPageThumbnails', {
            query: { vid: vid },
            retryCallback: function () { return _this.getCollaborationContentPageThumbnails(vid); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentAsPdf = function (vid) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CollaborationContentAsPdf', {
            query: { vid: vid },
            retryCallback: function () { return _this.getCollaborationContentAsPdf(vid); },
        });
    };
    CollaborationContentObjectService.prototype.updateCollaborationContentName = function (contentId, newName) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentObjectService', 'UpdateCollaborationContentName', newName, {
            query: { id: contentId },
            retryCallback: function () { return _this.updateCollaborationContentName(contentId, newName); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentObjectRelatedContent = function (collaborationContentVersionId) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CollaborationContentObjectRelatedContent', {
            query: { collaborationContentVersionId: collaborationContentVersionId },
            retryCallback: function () { return _this.getCollaborationContentObjectRelatedContent(collaborationContentVersionId); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentFormatInfo = function (versionid, format) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'GetCollaborationContentFormatInfo', {
            query: { versionid: versionid, format: format },
            retryCallback: function () { return _this.getCollaborationContentFormatInfo(versionid, format); },
        });
    };
    CollaborationContentObjectService.prototype.requestCollaborationContentFormat = function (versionid, format) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'RequestCollaborationContentFormat', {
            query: { versionid: versionid, format: format },
            retryCallback: function () { return _this.requestCollaborationContentFormat(versionid, format); },
        });
    };
    CollaborationContentObjectService.prototype.createNewVersionOfPDFFormat = function (contentid, versionid) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CreateNewVersionOfPDFFormat', {
            query: { contentid: contentid, versionid: versionid },
            retryCallback: function () { return _this.createNewVersionOfPDFFormat(contentid, versionid); },
        });
    };
    CollaborationContentObjectService.prototype.createTempVersionOfGdocFormat = function (contentid, versionid) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'CreateTempVersionOfGdocFormat', {
            query: { contentid: contentid, versionid: versionid },
            retryCallback: function () { return _this.createTempVersionOfGdocFormat(contentid, versionid); },
        });
    };
    CollaborationContentObjectService.prototype.revertToPPTXAndCreateNewVersion = function (contentid, versionid) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'RevertToPPTXAndCreateNewVersion', {
            query: { contentid: contentid, versionid: versionid },
            retryCallback: function () { return _this.revertToPPTXAndCreateNewVersion(contentid, versionid); },
        });
    };
    CollaborationContentObjectService.prototype.getUpdateToLatestVersion = function (contentId) {
        var _this = this;
        return this.jsonApiService.post('CollaborationContentObjectService', 'UpdateToLatestVersion', contentId, {
            retryCallback: function () { return _this.getUpdateToLatestVersion(contentId); },
        });
    };
    CollaborationContentObjectService.prototype.getCollaborationContentCollectionDownloadSummary = function (clientType, trackId) {
        var _this = this;
        return this.jsonApiService.get('CollaborationContentObjectService', 'GetCollaborationContentCollectionDownloadSummary', {
            query: { clientType: clientType, trackId: trackId },
            retryCallback: function () { return _this.getCollaborationContentCollectionDownloadSummary(clientType, trackId); },
        });
    };
    CollaborationContentObjectService = __decorate([
        CommonService_decorator_1.CommonService('CollaborationContentObjectService', { replaceAngularService: 'collaborationContentObjectService' }),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            LaunchDarkly_service_1.LaunchDarklyService])
    ], CollaborationContentObjectService);
    return CollaborationContentObjectService;
}());
exports.CollaborationContentObjectService = CollaborationContentObjectService;
//# sourceMappingURL=CollaborationContentObject.service.js.map